import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/image/unionCheckIcon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f3163c28")

_pushScopeId("data-v-f3163c28")
const _hoisted_1 = { class: "ui__header_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__header_report" }, [
  /*#__PURE__*/_createVNode("div", { class: "ui__header_title" }, "官方验货报告"),
  /*#__PURE__*/_createVNode("div", { class: "ui__header_text" }, [
    /*#__PURE__*/_createTextVNode(" 本报告由"),
    /*#__PURE__*/_createVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createTextVNode("联合查验 ")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2
  ]))
})